module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Rewind_16"],"path":[{"$":{"d":"M8,8l8-5V13Zm0,5V3L0,8Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Rewind_16.svg
// module id = /Csu
// module chunks = 1